export const auth = {
  //switch login
  REFRESH_TOKEN: '/auth/auth/refresh-token',
  TOKEN_EXCHANGE: '/auth/auth/token-exchange',
  LOGOUT: '/auth/auth/logout'
}
export const iam = {
  // Lấy thông tin user
  USER_INFO: '/iam/user/userInfo',
  ALL_CLIENT: 'iam/client/findAll'
}

export const sys = {
  GET_COMPANY_LIST: 'sys/orgUnit/initTree',
  GET_PROVINCE: 'sys/location/find-province',
  GET_DISTRICT: 'sys/location/find-district',
  GET_COMMUNE: 'sys/location/find-commune',
  GET_GLOBAL_LIST_DETAIL: 'sys/globalListDetail/getListGlobalValueByCode',
  GET_UNIT_STAFF: 'sys/orgUnitStaff/getStaffsByOrgUnit',
  GET_STAFF: 'sys/staff/search'
}
export const asm = {
  //tài sản
  ASSET_UNASSIGNED_HIER: 'asm/asset/unassigned-hier',
  ASSET_UNASSIGNED_PROJECT: 'asm/asset/unassigned-project',
  ASSET_MODEL_TECH_SPEC: 'asm/asset-model-tech-spec-data/search',
  ASSET_UPDATE_MODEL_TECH_SPEC: 'asm/asset-model-tech-spec-data/update-batch',

  ASSET_SEARCH: 'asm/asset/search',
  ASSET_DELETE: 'asm/asset/delete',
  ASSET_CREATE: 'asm/asset/create',
  ASSET_SELF: 'asm/asset/self',
  ASSET_UPDATE: 'asm/asset/update',
  ASSET_UPDATE_TECH_DEPRECIATION: 'asm/asset/update-tech-depreciation',

  ASSET_MTN_SEARCH: 'asm/asset-mtn/search',
  ASSET_MTN_UPDATE: 'asm/asset-mtn/update-batch',
  ASSET_MTN_REORDER: 'asm/asset-mtn/reorder',

  //danh sách công việc của chu kỳ bảo dưỡng
  ASSET_MTN_TASK_SEARCH: 'asm/asset-mtn-task/search',
  ASSET_MTN_TASK_UPDATE: 'asm/asset-mtn-task/update-batch',

  //danh sách vật tư bảo dưỡng
  ASSET_MTN_MATERIAL_SEARCH: 'asm/asset-mtn-material/search',
  ASSET_MTN_MATERIAL_UPDATE: 'asm/asset-mtn-material/update-batch',

  // danh sach lich su bao duong
  ASSET_MTN_HISTORY_SEARCH: 'asm/asset-mtn-his/search',
  ASSET_MTN_HISTORY_UPDATE: 'asm/asset-mtn-his/update-batch',

  // danh sach lich su sua chua
  ASSET_REPAIR_HISTORY_SEARCH: 'asm/asset-rpr-his/search',
  ASSET_REPAIR_HISTORY_UPDATE: 'asm/asset-rpr-his/update-batch',

  // danh sach ly lich tai san
  ASSET_BACKGROUND_SEARCH: 'asm/asset-bgd/search',
  ASSET_BACKGROUND_UPDATE: 'asm/asset-bgd/update-batch',

  //Tài liệu
  ASSET_DOCUMENT_SEARCH: 'asm/asset-doc/search',
  ASSET_DOCUMENT_UPDATE: 'asm/asset-doc/update-batch',
  ASSET_UPDATE_CONFIRM: 'asm/asset/update-confirm',

  //cây tài sản
  ASSET_HIER_SEARCH: 'asm/asset-hier/search',
  ASSET_HIER_CREATE: 'asm/asset-hier/create',
  ASSET_HIER_UPDATE: 'asm/asset-hier/update',
  ASSET_HIER_SELF: 'asm/asset-hier/self',
  ASSET_HIER_UPDATE_STATUS: 'asm/asset-hier/update-status',
  ASSET_HIER_DELETE: 'asm/asset-hier/delete',
  GRANT_ASSET: 'asm/asset-hier/grant-asset',
  REVOKE_ASSET: 'asm/asset-hier/revoke-asset',
  RE_ORDER_TREE_ASSET_HIER: 'asm/asset-hier/update-display-order',
  GET_ASSET_HIER_LIST: 'asm/asset-hier/tree',
  ASM_SEARCH: 'asm/asset/search',

  //nhóm tài sản
  ASSET_GROUP_SEARCH: 'asm/asset-group/search',
  ASSET_GROUP_CREATE: 'asm/asset-group/create',
  ASSET_GROUP_UPDATE: 'asm/asset-group/update',
  ASSET_GROUP_DELETE: 'asm/asset-group/delete',
  ASSET_GROUP_UPDATE_STATUS: 'asm/asset-group/update-status',
  ASSET_GROUP_GANT_MODEL: 'asm/asset-group/grant-asset-model',
  ASSET_GROUP_REVOKE_MODEL: 'asm/asset-group/revoke-asset-model',
  ASSET_GROUP_GET_MODEL: 'asm/asset-model/search',
  ASSET_GROUP_GET_UNASSIGNED_MODEL: 'asm/asset-model/unassigned-group',
  ASSET_GROUP_DELETE_MODEL: 'asm/asset-model/delete',

  //Danh sách dự án
  PROJECT_LIST_SEARCH: 'asm/asset-project/search',
  PROJECT_LIST_DETAIL: 'asm/asset-project/self',
  PROJECT_LIST_UPDATE: 'asm/asset-project/update',
  PROJECT_LIST_CREATE: 'asm/asset-project/create',
  PROJECT_LIST_GRANT_ASSET: 'asm/asset-project/grant-asset',
  PROJECT_LIST_REVOKE_ASSET: 'asm/asset-project/revoke-asset',
  PROJECT_LIST_GET_DOC: 'asm/asset-project-doc/search',
  PROJECT_LIST_UPDATE_DOC: 'asm/asset-project-doc/update-batch',

  //Danh sách hợp đồng của dự án
  CONTRACT_PROJECT_LIST_SEARCH: 'asm/asset-project-contract/search',
  CONTRACT_PROJECT_LIST_DETAIL: 'asm/asset-project-contract/self',
  CONTRACT_PROJECT_LIST_CREATE: 'asm/asset-project-contract/create',
  CONTRACT_PROJECT_LIST_UPDATE: 'asm/asset-project-contract/update',
  CONTRACT_PROJECT_LIST_DELETE: 'asm/asset-project-contract/delete',
  CONTRACT_PROJECT_LIST_GET_DOC: 'asm/asset-project-contract-doc/search',
  CONTRACT_PROJECT_LIST_UPDATE_DOC: 'asm/asset-project-contract-doc/update-batch',

  //chủng loại tài sản
  ASSET_MODEL_SEARCH: 'asm/asset-model/search',
  ASSET_MODEL_DELETE: 'asm/asset-model/delete',
  ASSET_MODEL_CREATE: 'asm/asset-model/create',
  ASSET_MODEL_UPDATE: 'asm/asset-model/update',
  ASSET_MODEL_SELF: 'asm/asset-model/self',
  ASSET_MODEL_UPDATE_STATUS: 'asm/asset-model/update-status',

  //thông số kỹ thuật riêng
  ASSET_MODEL_TECH_SPEC_SEARCH: 'asm/asset-model-tech-spec/search',
  ASSET_MODEL_TECH_SPEC_UPDATE_BATCH: 'asm/asset-model-tech-spec/update-batch',

  //chu kỳ bảo dưỡng
  ASSET_MODEL_MTN_SEARCH: 'asm/asset-model-mtn/search',
  ASSET_MODEL_MTN_UPDATE: 'asm/asset-model-mtn/update-batch',
  ASSET_MODEL_MTN_REORDER: 'asm/asset-model-mtn/reorder',

  //danh sách công việc của chu kỳ bảo dưỡng
  ASSET_MODEL_MTN_TASK_SEARCH: 'asm/asset-model-mtn-task/search',
  ASSET_MODEL_MTN_TASK_UPDATE: 'asm/asset-model-mtn-task/update-batch',

  //danh sách vật tư bảo dưỡng
  ASSET_MODEL_MTN_MATERIAL_SEARCH: 'asm/asset-model-mtn-material/search',
  ASSET_MODEL_MTN_MATERIAL_UPDATE: 'asm/asset-model-mtn-material/update-batch',

  //Vật tư
  INVENTORY_ITEM_SEARCH: 'asm/invt-item/search',
  INVENTORY_ITEM_DETAIL: 'asm/invt-item/self',
  INVENTORY_ITEM_CREATE: 'asm/invt-item/create',
  INVENTORY_ITEM_UPDATE: 'asm/invt-item/update',
  INVENTORY_ITEM_DELETE: 'asm/invt-item/delete',

  //Tài liệu
  ASSET_MODEL_DOCUMENT_SEARCH: 'asm/asset-model-doc/search',
  ASSET_MODEL_DOCUMENT_UPDATE: 'asm/asset-model-doc/update-batch',

  //Kế hoạch bảo dưỡng thực tế
  ACTUAL_MAINTENANCE_PLAN_SEARCH: 'asm/asset-mtn-reality/search',
  ACTUAL_MAINTENANCE_PLAN_DETAIL: 'asm/asset-mtn-reality/self',
  ACTUAL_MAINTENANCE_PLAN_UPDATE: 'asm/asset-mtn-reality/update',
  ACTUAL_MAINTENANCE_PLAN_GET_CYCLE: 'asm/asset-mtn-reality/cycle',
  ACTUAL_MAINTENANCE_PLAN_INIT_DATA: 'asm/asset-mtn-reality/init',

  //Lấy tài sản cho bảo dưỡng thưực tế
  ACTUAL_MAINTENANCE_UNASSIGNED_MTN: 'asm/asset/unassigned-mtn-reality',

  //Kế hoạch bảo dưỡng theo năm
  ANNUAL_MAINTENANCE_PLAN_SEARCH: 'asm/asset-mtn-year/search',
  ANNUAL_MAINTENANCE_PLAN_DETAIL: 'asm/asset-mtn-year/self',
  ANNUAL_MAINTENANCE_PLAN_UPDATE: 'asm/asset-mtn-year/update',
  ANNUAL_MAINTENANCE_PLAN_CANCEL: 'asm/asset-mtn-year/approve/cancel',
  ANNUAL_MAINTENANCE_PLAN_CONFIRM: 'asm/asset-mtn-year/approve/confirm',
  ANNUAL_MAINTENANCE_PLAN_REFUSE: 'asm/asset-mtn-year/refuse',
  ANNUAL_MAINTENANCE_PLAN_REQUEST: 'asm/asset-mtn-year/approve/request',
  ANNUAL_MAINTENANCE_PLAN_GET_CYCLE: 'asm/asset-mtn-year/cycle',
  ANNUAL_MAINTENANCE_PLAN_INIT_DATA: 'asm/asset-mtn-year/init',

  //Lấy tài sản cho kế hoạch bảo dưỡng năm
  ANNUAL_MAINTENANCE_UNASSIGNED_MTN_YEAR: 'asm/asset/unassigned-mtn-year',

  //Kế hoạch bảo dưỡng khuyến cáo
  RECOMMEND_PLAN_SEARCH: 'asm/asset-mtn-recom/search',
  RECOMMEND_PLAN_GET_CYCLE: 'asm/asset-mtn-recom/cycle',
  RECOMMEND_PLAN_INIT_DATA: 'asm/asset-mtn-recom/init',

  //Mã QR thông tin tài sản
  INFORMATION_ASSETS_QR_SEARCH: 'asm/asset-qr/search',
  INFORMATION_ASSETS_QR_UPDATE: 'asm/asset-qr/update-batch'
}

export const fsm = {
  GET_FILE: 'fsm/file/list',
  GET_FILE_BY_KEY: 'fsm/file/get-by-key',
  UPLOAD_MULTIPART_FILE: 'fsm/file/upload-multipart'
}
